import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { isRetryableApiError } from "Infrastructure/Api/ApiUtils";
import { reportApiError } from "Infrastructure/Api/reportApiError";

export const QUERY_MAX_RETRY_COUNT = 2;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Queries throw either an ApiCallError or the raw error response
      // (processResponseWithApiProblemDetails); isRetryableApiError reads
      // the status from both shapes.
      retry: (failureCount, error) =>
        isRetryableApiError(error) && failureCount < QUERY_MAX_RETRY_COUNT,
    },
  },
  // Failed requests are reported to Sentry only - never toasted from here.
  // A hook or call site that wants user-facing feedback opts in with its own
  // translated message.
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.skipErrorReporting) {
        return;
      }

      reportApiError(error);
    },
  }),
  // Unlike defaultOptions.mutations.onError (which a mutation's own onError
  // replaces), MutationCache.onError always fires - so every mutation gets
  // reported regardless of its local error handling.
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.meta?.skipErrorReporting) {
        return;
      }

      reportApiError(error);
    },
  }),
});
